import { useMutation, useQueryClient } from '@tanstack/react-query';
import { convertCSv } from 'services/self-serve-magic-link';
import { showSuccessNotification } from 'services/common';

// eslint-disable-next-line import/prefer-default-export
export const useConvertSSMagicLinkCsv = () => {
  const queryClient = useQueryClient();
  return useMutation(
    file => {
      const formData = new FormData();
      formData.append('file', file);
      return convertCSv(formData);
    },
    {
      onSuccess: () => {
        showSuccessNotification(
          'CSV upload successfully. Result will be updated soon',
        );
        void queryClient.invalidateQueries('uploadedSSMagicLinkCSV');
      },
    },
  );
};
